module.exports = __webpack_public_path__ + "static/media/amazon-textract-logo.d2262b9d.png";